module.exports = __webpack_public_path__ + "static/media/ibd_foot1.dfa4cff4.png";